
function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/userCenter/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'userCenter')
    }
}

let routes = [
    {
        name: 'my',
        path: '/ems/my',
        meta: {
            title: '个人中心'
        }
    },
    {
        name: 'subUsersDetail',
        path: '/ems/user/detail',
        meta: {
            title: '账号详情'
        }
    },
    {
        name: 'resetPassword',
        path: '/ems/resetPassword',
        meta: {
            title: '修改密码'
        }
    },

    {
        name: 'addSuccess',
        path: '/ems/team/success',
        meta: {
            title: '技术人员开通成功'
        }
    },
    {
        name: 'certificate',
        path: '/ems/certificate',
        meta: {
            title: '资格证件'
        }
    },
    {
        name: 'feedback',
        path: '/ems/feedback',
        meta: {
            title: '意见反馈'
        }
    },
    {
        name: 'authorize',
        path: '/ems/authorize',
        meta: {
            title: '授权管理'
        }
    },
    {
        name: 'setting',
        path: '/ems/setting',
        meta: {
            title: '设置'
        }
    },
    {
        name: 'teamMsg',
        path: '/ems/teamMsg',
        meta: {
            title: '加入团队'
        }
    },
    {
        name: 'workMsg',
        path: '/ems/workMsg',
        meta: {
            title: '工作信息'
        }
    },
    {
        name: 'appDownload',
        path: '/ems/appDownload',
        meta: {
            title: '领筑维保'
        }
    }
]
routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes








// WEBPACK FOOTER //
// ./src/router/modules/ems/userCenter.js